import { DataType } from '@/util/index'
import SystemEnum from '@/assets/js/systemEnum'
const WORK_QUEUE = SystemEnum.WORK_QUEUE_ENUM
const QUEUE = [
  {
    status: WORK_QUEUE.AGENT_REVIEW.value,
    title: WORK_QUEUE.AGENT_REVIEW.text,
    key: WORK_QUEUE.AGENT_REVIEW.key,
    features: WORK_QUEUE.AGENT_REVIEW.features,
    color: ['#5C82E3', '#F2F5FD'],
    code: DataType.PrivilegeCode.AGENT_REVIEW_QUEUE,
    count: 0,
    items: [],
    indexOfPage: 1,
    isEnd: true,
    isLoading: true
  },
  {
    status: WORK_QUEUE.RETURNING.value,
    title: WORK_QUEUE.RETURNING.text,
    key: WORK_QUEUE.RETURNING.key,
    features: WORK_QUEUE.RETURNING.features,
    color: ['#685DE8', '#F3F2FD'],
    filter: {
      customerType: [DataType.CategoryEnum.RETURNING_CUSTOMER.value]
    },
    code: DataType.PrivilegeCode.RETURNING_QUEUE,
    count: 0,
    items: [],
    indexOfPage: 1,
    isEnd: true,
    isLoading: true
  },
  {
    status: WORK_QUEUE.CORRECTOR_REVIEW.value,
    title: WORK_QUEUE.CORRECTOR_REVIEW.text,
    key: WORK_QUEUE.CORRECTOR_REVIEW.key,
    features: WORK_QUEUE.CORRECTOR_REVIEW.features,
    color: ['#B05CE3', '#F9F4FF'],
    config: {
      displayNotes: true
    },
    code: DataType.PrivilegeCode.CORRECTOR_REVIEW_QUEUE,
    count: 0,
    items: [],
    indexOfPage: 1,
    isEnd: true,
    isLoading: true
  },
  {
    status: WORK_QUEUE.UNDERWRITER_REVIEW.value,
    title: WORK_QUEUE.UNDERWRITER_REVIEW.text,
    key: WORK_QUEUE.UNDERWRITER_REVIEW.key,
    features: WORK_QUEUE.UNDERWRITER_REVIEW.features,
    color: ['#EAA0C8', '#FEFAFC'],
    code: DataType.PrivilegeCode.UNDERWRITER_REVIEW_QUEUE,
    count: 0,
    items: [],
    indexOfPage: 1,
    isEnd: true,
    isLoading: true,
    iconItem: {
      icon: 'open_in_new',
      tooltip: 'Export',
      code: DataType.PrivilegeCode.EXPORT_UNDERWRITER_QUEUE
    }
  },
  {
    status: WORK_QUEUE.TRIBE_REVIEW.value,
    title: WORK_QUEUE.TRIBE_REVIEW.text,
    key: WORK_QUEUE.TRIBE_REVIEW.key,
    features: WORK_QUEUE.TRIBE_REVIEW.features,
    color: ['#F67E9B', '#FFF5F8'],
    code: DataType.PrivilegeCode.TRIBE_REVIEW_QUEUE,
    count: 0,
    items: [],
    indexOfPage: 1,
    isEnd: true,
    isLoading: true,
    iconItem: {
      icon: 'open_in_new',
      tooltip: 'Batch Approve',
      code: DataType.PrivilegeCode.TRIBE_REVIEW_BATCH_APPROVE
    }
  },
  {
    status: WORK_QUEUE.POSITIVE_WITHDRAW.value,
    title: WORK_QUEUE.POSITIVE_WITHDRAW.text,
    key: WORK_QUEUE.POSITIVE_WITHDRAW.key,
    features: WORK_QUEUE.POSITIVE_WITHDRAW.features,
    color: ['#FFC700', '#FFFCF2'],
    code: DataType.PrivilegeCode.POSITIVE_WITHDRAWN_QUEUE,
    count: 0,
    items: [],
    indexOfPage: 1,
    isEnd: true,
    isLoading: true
  },
  {
    status: WORK_QUEUE.NEGATIVE_WITHDRAW.value,
    title: WORK_QUEUE.NEGATIVE_WITHDRAW.text,
    key: WORK_QUEUE.NEGATIVE_WITHDRAW.key,
    features: WORK_QUEUE.NEGATIVE_WITHDRAW.features,
    color: ['#F37070', '#FFF4F4'],
    code: DataType.PrivilegeCode.NEGATIVE_WITHDRAWN_QUEUE,
    count: 0,
    items: [],
    indexOfPage: 1,
    isEnd: true,
    isLoading: true
  },
  {
    status: WORK_QUEUE.TO_BE_SIGNED.value,
    title: WORK_QUEUE.TO_BE_SIGNED.text,
    key: WORK_QUEUE.TO_BE_SIGNED.key,
    features: WORK_QUEUE.TO_BE_SIGNED.features,
    filter: {
      signedStatus: [DataType.SignStatusEnum.NOT_SIGNED.value, DataType.SignStatusEnum.EXPIRED.value]
    },
    color: ['#5BCDF2', '#F2FBFE'],
    config: {
      displayApplicationStatus: true
    },
    code: DataType.PrivilegeCode.TO_BE_SIGNED_QUEUE,
    count: 0,
    items: [],
    indexOfPage: 1,
    isEnd: true,
    isLoading: true
  },
  {
    status: WORK_QUEUE.TO_BE_SUBMITTED.value,
    title: WORK_QUEUE.TO_BE_SUBMITTED.text,
    key: WORK_QUEUE.TO_BE_SUBMITTED.key,
    features: WORK_QUEUE.TO_BE_SUBMITTED.features,
    filter: {
      signedStatus: [DataType.SignStatusEnum.SIGNED.value]
    },
    color: ['#64CA99', '#EFFFF7'],
    config: {
      displayApplicationStatus: true
    },
    code: DataType.PrivilegeCode.TO_BE_SUBMITTED_QUEUE,
    count: 0,
    items: [],
    indexOfPage: 1,
    isEnd: true,
    isLoading: true
  },
  {
    status: WORK_QUEUE.FRAUD_WARNING.value,
    title: WORK_QUEUE.FRAUD_WARNING.text,
    key: WORK_QUEUE.FRAUD_WARNING.key,
    features: WORK_QUEUE.FRAUD_WARNING.features,
    color: ['#ee0b0b', '#F2F5FD'],
    code: DataType.PrivilegeCode.FRAUD_WARNING_QUEUE,
    filter: {
      fraudStatus: [1, -1, 2]
    },
    count: 0,
    items: [],
    indexOfPage: 1,
    isEnd: true,
    isLoading: true
  },
  {
    status: WORK_QUEUE.SUSPECTED_LITIGANT.value,
    title: WORK_QUEUE.SUSPECTED_LITIGANT.text,
    key: WORK_QUEUE.SUSPECTED_LITIGANT.key,
    features: WORK_QUEUE.SUSPECTED_LITIGANT.features,
    color: ['#FFC700', '#F2F5FD'],
    code: DataType.PrivilegeCode.PRE_SUSPECTED_LITIGANT_QUEUE,
    filter: {
      litigantStatus: [0]
    },
    count: 0,
    items: [],
    indexOfPage: 1,
    isEnd: true,
    isLoading: true
  },
  {
    status: WORK_QUEUE.TRIBE_NOAA_REVIEW.value,
    title: WORK_QUEUE.TRIBE_NOAA_REVIEW.text,
    key: WORK_QUEUE.TRIBE_NOAA_REVIEW.key,
    features: WORK_QUEUE.TRIBE_NOAA_REVIEW.features,
    color: ['#FFC700', '#F2F5FD'],
    code: DataType.PrivilegeCode.TRIBE_NOAA_REVIEW,
    count: 0,
    items: [],
    indexOfPage: 1,
    isEnd: true,
    isLoading: true
  }
]
export default QUEUE
